<template>
    <div
        v-if="event"
        :key="event._id"
        :id="'event-' + event._id"
        class="event-item clearfix"
    >
        <div class="event-item-content event-theater" v-if="event.is_theater">
            <a :href="event.url" class="event-item-link">
                <div class="event-image-container">
                    <img
                        src="/wp-content/uploads/2024/02/Theater-Aachen-1-300x225.jpeg"
                        width="300"
                        height="200"
                        class="event-item-image"
                        alt="Theater Aachen"
                    />
                </div>
                <div class="event-category">{{ event.main_cat }}</div>
                <h3 class="event-title" v-html="event.title"></h3>
                <div class="event-venue">{{ event.venue }}</div>
                <span class="cta">zum Spielplan</span>

            </a>
        </div>
        <div class="event-item-content" v-else>
            <a
                :href="'/termin?eid='+event._id"
                class="event-item-link"
            >
                <div class="event-image-container" v-if="event.images">
                    <img
                        v-if="full"
                        :src="event.images.large.url"
                        :width="event.images.large.width"
                        :height="event.images.large.height"
                        class="event-item-image"
                        :alt="event.title"
                    />
                    <img
                        v-else
                        :src="event.images.medium.url"
                        :width="event.images.medium.width"
                        :height="event.images.medium.height"
                        class="event-item-image"
                        :alt="event.title"
                    />
                </div>

                <div class="event-category">{{ event.main_cat }}</div>

                <h3 class="event-title" v-html="event.title"></h3>

                <div class="event-venue">{{ event.venue }}</div>
                <div class="date" v-if="event.sameday">
                    <div class="event-date weekday">{{ event.start_date | moment("dddd") }}</div>
                    <div class="event-date day">{{ event.start_date | moment("DD. MMMM") }}</div>
                    <template v-if="!event.allday">
                        <template v-if="event.sametime">
                            <div class="event-date time">{{ event.start_time }} Uhr</div>
                        </template>
                        <template v-else>
                            <div class="event-date time">
                                {{ event.start_time }} &ndash;
                                {{ event.end_time }}
                                Uhr
                            </div>
                        </template>
                    </template>
                    <template v-if="event.allday">
                        <div class="event-date time" v-if="event.sametime">{{ event.start_date | moment("HH.mm") }} Uhr</div>
                    </template>
                </div>

                <div class="date" v-else>
                    <div
                        class="event-date weekday"
                    >{{ event.start_day_month_year}} bis</div>
                    <div class="event-date day">{{ event.end_day_month_year}}</div>
                </div>
                <span class="cta">Details</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'event' : Object,
        'full' : Boolean,
    },
    data() {
        return {}
    },
    methods: {

    },
}
</script>
